module.exports = __webpack_public_path__ + "img/logopb.f29f2f22.png";